import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { importAmd } from 'src/utils/require_amd';
import { DarkLoadingSpinner } from 'src/domains/layouts/webview/components/loaders/loadingSpinner/LoadingSpinner';
import { PaymentIframeDataType } from './PaysafeFrameOptions';
import { PaysafePaymentProviderType } from 'src/domains/layouts/config/features/types';
import { PaysafeTabState as MultiDepositPaysafeTabState } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/multiDepositJourney/PaysafeTab/PaysafeTab.state';
import { PaysafeTabState as SinglePaysafeTabState } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/paysafeProvider/PaysafeTab.state';

export interface PaysafeFramePropsType {
    paymentIframeData: PaymentIframeDataType;
    paysafeTabState: SinglePaysafeTabState | MultiDepositPaysafeTabState;
    paysafePaymentProvider: PaysafePaymentProviderType;
}

export const PaysafeFrame = observer(
    'PaysafeiFrame',
    ({ paymentIframeData, paysafeTabState, paysafePaymentProvider }: PaysafeFramePropsType): JSX.Element => {
        React.useEffect(() => {
            const initPayment = async (): Promise<void> => {
                if (paysafePaymentProvider.environment === 'TEST') {
                    await importAmd(`https://hosted.test.paysafe.com/checkout/v2/paysafe.checkout.min.js`);
                } else {
                    await importAmd(`https://hosted.paysafe.com/checkout/v2/paysafe.checkout.min.js`);
                }

                //@ts-expect-error
                window.paysafe.checkout.setup(
                    paysafePaymentProvider.apiKey,
                    paymentIframeData.data,
                    paysafeTabState.paysafeResultCallback(paymentIframeData),
                    paysafeTabState.paysafeStateCallback
                );
            };
            initPayment().catch((err) => {
                console.error('paysafe-iframe-init', err);
                if ('stepsState' in paysafeTabState) {
                    paysafeTabState.stepsState.redirectToFailureView('serverIssue');
                }
            });
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        return (
            <div>
                <DarkLoadingSpinner />
            </div>
        );
    }
);
